import { useRouter } from 'vue-router'

import useOuraAuth from '#web-oura-tools/auth'

import { useServicesStore } from '#ourahub-intra/stores/services'

import type { Service } from '#ourahub-intra/types/services'
import type { AppEnvironment } from '#web-oura-tools/types/auth'

import { logModuleEvent } from '#web-oura-tools/stats/internal'

export function useServiceLaunch() {
  const router = useRouter()

  const ouraAuth = useOuraAuth()

  const servicesStore = useServicesStore()

  async function launchService(service: Service, stage?: AppEnvironment) {
    stage = stage ?? (service.public as AppEnvironment)

    if (servicesStore.isLaunchableInNewTab(service)) {
      servicesStore.trackServiceOpen(service)

      await logModuleEvent(stage, service.id)

      window.open(service.entry![stage] + (service.url ?? ''), '_blank')

      return
    }

    if (ouraAuth.appEnv.value !== stage) {
      await ouraAuth.changeEnvironment(stage)
    }

    await router.push({ name: service.id, params: { env: stage } })

    if (service.url) {
      window.history.replaceState(null, '', `${service.url}#${stage}/${service.id}`)
    }
  }

  return { launchService }
}
